import { StatsWidgetActions, } from '@Store/types';
import { IStatsWidgetDataPayload, } from 'atlas-shared/dist';

export * from './abstract/stats_widget.actions.abstract';

export const actionUpdateStatsWidgetData = (payload: IStatsWidgetDataPayload) => ({
  type: StatsWidgetActions.SET_DATA,
  payload: payload,
});
